import { render, staticRenderFns } from "./FreeePostErrorDialog.vue?vue&type=template&id=35e0bf7e&"
import script from "./FreeePostErrorDialog.vue?vue&type=script&lang=js&"
export * from "./FreeePostErrorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports